var _g, _path, _path2, _path3, _circle, _circle2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCryingFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.00 0.00 216.00 213.00",
    width: 216,
    height: 213,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "butt"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#889095",
    d: " M 173.94 108.00 A 65.94 65.94 0.0 0 0 108.00 42.06 A 65.94 65.94 0.0 0 0 42.06 108.00 A 65.94 65.94 0.0 0 0 108.00 173.94 A 65.94 65.94 0.0 0 0 173.94 108.00"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#889095",
    d: " M 164.65 108.10 A 56.64 56.64 0.0 0 0 108.01 51.46 A 56.64 56.64 0.0 0 0 51.37 108.10 A 56.64 56.64 0.0 0 0 108.01 164.74 A 56.64 56.64 0.0 0 0 164.65 108.10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#889095",
    d: " M 93.82 89.14 A 9.39 9.39 0.0 0 0 84.43 79.75 A 9.39 9.39 0.0 0 0 75.04 89.14 A 9.39 9.39 0.0 0 0 84.43 98.53 A 9.39 9.39 0.0 0 0 93.82 89.14"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#889095",
    d: " M 140.95 89.14 A 9.38 9.38 0.0 0 0 131.57 79.76 A 9.38 9.38 0.0 0 0 122.19 89.14 A 9.38 9.38 0.0 0 0 131.57 98.52 A 9.38 9.38 0.0 0 0 140.95 89.14"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#889095",
    d: " M 108.11 117.47 Q 121.09 117.46 130.35 131.79 C 131.49 133.55 132.63 136.56 134.59 137.65 C 138.51 139.82 142.76 135.62 140.90 131.57 C 134.97 118.68 122.79 108.16 108.11 108.17 C 93.42 108.17 81.25 118.70 75.33 131.59 C 73.47 135.65 77.73 139.84 81.64 137.67 C 83.60 136.58 84.74 133.57 85.88 131.81 Q 95.13 117.47 108.11 117.47"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#11202b",
    d: " M 112.98 0.00 Q 137.88 1.41 158.90 12.61 Q 192.14 30.31 207.64 65.37 Q 214.80 81.55 216.00 101.49 L 216.00 111.22 Q 214.86 131.40 207.42 148.17 Q 190.25 186.87 150.77 204.28 Q 133.72 211.80 113.10 213.00 L 103.04 213.00 Q 77.36 211.55 55.79 199.69 Q 23.44 181.90 8.29 147.48 Q 1.20 131.36 0.00 111.54 L 0.00 101.62 Q 1.84 70.47 18.66 46.66 Q 48.87 3.94 102.89 0.00 L 112.98 0.00 Z M 173.94 108.00 A 65.94 65.94 0.0 0 0 108.00 42.06 A 65.94 65.94 0.0 0 0 42.06 108.00 A 65.94 65.94 0.0 0 0 108.00 173.94 A 65.94 65.94 0.0 0 0 173.94 108.00 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: " M 173.94 108.00 A 65.94 65.94 0.0 0 1 108.00 173.94 A 65.94 65.94 0.0 0 1 42.06 108.00 A 65.94 65.94 0.0 0 1 108.00 42.06 A 65.94 65.94 0.0 0 1 173.94 108.00 Z M 164.65 108.10 A 56.64 56.64 0.0 0 0 108.01 51.46 A 56.64 56.64 0.0 0 0 51.37 108.10 A 56.64 56.64 0.0 0 0 108.01 164.74 A 56.64 56.64 0.0 0 0 164.65 108.10 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#11202b",
    d: " M 164.65 108.10 A 56.64 56.64 0.0 0 1 108.01 164.74 A 56.64 56.64 0.0 0 1 51.37 108.10 A 56.64 56.64 0.0 0 1 108.01 51.46 A 56.64 56.64 0.0 0 1 164.65 108.10 Z M 93.82 89.14 A 9.39 9.39 0.0 0 0 84.43 79.75 A 9.39 9.39 0.0 0 0 75.04 89.14 A 9.39 9.39 0.0 0 0 84.43 98.53 A 9.39 9.39 0.0 0 0 93.82 89.14 Z M 140.95 89.14 A 9.38 9.38 0.0 0 0 131.57 79.76 A 9.38 9.38 0.0 0 0 122.19 89.14 A 9.38 9.38 0.0 0 0 131.57 98.52 A 9.38 9.38 0.0 0 0 140.95 89.14 Z M 108.11 117.47 Q 121.09 117.46 130.35 131.79 C 131.49 133.55 132.63 136.56 134.59 137.65 C 138.51 139.82 142.76 135.62 140.90 131.57 C 134.97 118.68 122.79 108.16 108.11 108.17 C 93.42 108.17 81.25 118.70 75.33 131.59 C 73.47 135.65 77.73 139.84 81.64 137.67 C 83.60 136.58 84.74 133.57 85.88 131.81 Q 95.13 117.47 108.11 117.47 Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#ffffff",
    cx: 84.43,
    cy: 89.14,
    r: 9.39
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#ffffff",
    cx: 131.57,
    cy: 89.14,
    r: 9.38
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: " M 108.11 108.17 C 122.79 108.16 134.97 118.68 140.90 131.57 C 142.76 135.62 138.51 139.82 134.59 137.65 C 132.63 136.56 131.49 133.55 130.35 131.79 Q 121.09 117.46 108.11 117.47 Q 95.13 117.47 85.88 131.81 C 84.74 133.57 83.60 136.58 81.64 137.67 C 77.73 139.84 73.47 135.65 75.33 131.59 C 81.25 118.70 93.42 108.17 108.11 108.17 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryingFace);
export default __webpack_public_path__ + "static/media/cryingFace.85ea6c69b0020e8c7680cb1448f829c1.svg";
export { ForwardRef as ReactComponent };